import { RowsIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Banner = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <RowsIcon {...rest} size={Sizes[size]} color={fill} />;
};

Banner.displayName = 'Banner';
